export function extractFilterParams(
  selectedFilters: Array<{
    kind: string;
    id: string;
    searchTypes?: ReadonlyArray<string>;
    schemaApiIds?: ReadonlyArray<string>;
  }>
): {
  schemaApiIds: Array<string>;
  objectTypes: Array<string>;
  // Global search types a Type dropdown selection narrows `allowedTypes` to; empty when none.
  searchTypes: Array<string>;
  projectApiIds: Array<string>;
  folderApiIds: Array<string>;
  authorApiIds: Array<string>;
} {
  return {
    schemaApiIds: [
      ...new Set(
        selectedFilters.flatMap((f) =>
          f.kind === 'schema' ? [f.id] : f.kind === 'type' ? (f.schemaApiIds ?? []) : []
        )
      ),
    ],
    objectTypes: selectedFilters.filter((f) => f.kind === 'type' && f.searchTypes == null).map((f) => f.id),
    searchTypes: [...new Set(selectedFilters.flatMap((f) => f.searchTypes ?? []))],
    projectApiIds: selectedFilters.filter((f) => f.kind === 'project').map((f) => f.id),
    folderApiIds: selectedFilters.filter((f) => f.kind === 'folder').map((f) => f.id),
    authorApiIds: selectedFilters.filter((f) => f.kind === 'user').map((f) => f.id),
  };
}
